import React from 'react'

const OfflineScheduleTemplate = ({ data }) => {
  const {
    companyName = '',
    roleName = '',
    assessmentType = 'Assessment',
    date = '',
    time = '',
    venue = '',
    note = '',
    signatureName = '',
    signatureContact = '',
  } = data

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px', color: '#333' }}>
      <p>Dear Candidate,</p>

      <p style={{ paddingTop: '8px' }}>
        Greetings from {companyName}!
      </p>

      <p style={{ paddingTop: '8px' }}>
        Your {assessmentType.toLowerCase()} for the role of{' '}
        <strong>{roleName}</strong> has been scheduled.
      </p>

      <p style={{ paddingTop: '8px', margin: '0px' }}>
        <strong>Date:</strong> {date}
      </p>
      <p style={{ paddingTop: '2px', margin: '0px' }}>
        <strong>Time:</strong> {time}
      </p>
      <p style={{ paddingTop: '2px', margin: '0px' }}>
        <strong>Venue:</strong> {venue}
      </p>

      {note && (
        <p style={{ paddingTop: '8px', margin: '0px', whiteSpace: 'pre-wrap' }}>
          <strong>Note/Instructions:</strong> {note}
        </p>
      )}

      <p style={{ paddingTop: '8px' }}>
        Please report to the venue on time and carry a valid ID proof.
      </p>

      <p style={{ paddingTop: '8px' }}>
        For any queries, feel free to reach out.
      </p>

      <p style={{ paddingTop: '10px', paddingBottom: '2px', margin: '0px' }}>Best Regards,</p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{signatureName}</p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>PluginLive</p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{signatureContact}</p>
    </div>
  )
}

export default OfflineScheduleTemplate
